import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination"
}
const _hoisted_2 = ["disabled", "aria-label"]
const _hoisted_3 = ["disabled", "aria-label"]
const _hoisted_4 = { class: "pagination-info" }
const _hoisted_5 = { class: "page-numbers" }
const _hoisted_6 = { class: "total-items" }
const _hoisted_7 = ["disabled", "aria-label"]
const _hoisted_8 = ["disabled", "aria-label"]

import { computed } from 'vue';

interface Props {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  itemsLabel?: string;
}

interface Emits {
  (e: 'update:currentPage', value: number): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationControls',
  props: {
    currentPage: {},
    pageSize: {},
    totalItems: {},
    itemsLabel: { default: 'items' }
  },
  emits: ["update:currentPage"],
  setup(__props: any, { emit: __emit }) {

// @ts-ignore
const props = __props;

const emit = __emit;

const totalPages = computed(() => {
  return Math.ceil(props.totalItems / props.pageSize);
});

const goToFirstPage = () => {
  if (props.currentPage !== 1) {
    emit('update:currentPage', 1);
  }
};

const goToPreviousPage = () => {
  if (props.currentPage > 1) {
    emit('update:currentPage', props.currentPage - 1);
  }
};

const goToNextPage = () => {
  if (props.currentPage < totalPages.value) {
    emit('update:currentPage', props.currentPage + 1);
  }
};

const goToLastPage = () => {
  if (props.currentPage !== totalPages.value) {
    emit('update:currentPage', totalPages.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.totalItems > _ctx.pageSize)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: goToFirstPage,
          disabled: _ctx.currentPage === 1,
          class: "pagination-btn",
          "aria-label": _ctx.$t('common.pagination.first')
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-angle-double-left" }, null, -1)
        ]))], 8, _hoisted_2),
        _createElementVNode("button", {
          onClick: goToPreviousPage,
          disabled: _ctx.currentPage === 1,
          class: "pagination-btn",
          "aria-label": _ctx.$t('common.pagination.previous')
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
        ]))], 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.pagination.page')) + " " + _toDisplayString(_ctx.currentPage) + " " + _toDisplayString(_ctx.$t('common.pagination.of')) + " " + _toDisplayString(totalPages.value), 1),
          _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.totalItems) + " " + _toDisplayString(_ctx.itemsLabel) + ") ", 1)
        ]),
        _createElementVNode("button", {
          onClick: goToNextPage,
          disabled: _ctx.currentPage === totalPages.value,
          class: "pagination-btn",
          "aria-label": _ctx.$t('common.pagination.next')
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
        ]))], 8, _hoisted_7),
        _createElementVNode("button", {
          onClick: goToLastPage,
          disabled: _ctx.currentPage === totalPages.value,
          class: "pagination-btn",
          "aria-label": _ctx.$t('common.pagination.last')
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fas fa-angle-double-right" }, null, -1)
        ]))], 8, _hoisted_8)
      ]))
    : _createCommentVNode("", true)
}
}

})